/**
 * 阴影工具：将拆分字段（shadowX/Y/blur/color/enabled）组装为 CSS box-shadow，
 * 并兼容旧版整体字符串 boxShadow（0 0 8px rgba(...)）。
 */

/** 从组件读取阴影相关字段（base > config > style 兼容） */
function readField(comp: any, key: string, def: unknown): any {
  if (comp?.base && comp.base[key] !== undefined) return comp.base[key];
  if (comp?.config && comp.config[key] !== undefined) return comp.config[key];
  if (comp?.style && comp.style[key] !== undefined) return comp.style[key];
  return def;
}

/** 组装 box-shadow（优先拆分字段，回退旧字符串） */
export function resolveBoxShadow(comp: any): string | undefined {
  const legacy = readField(comp, 'boxShadow', '');
  const enabled = readField(comp, 'shadowEnabled', legacy ? true : false);
  if (!enabled) return undefined;

  const x = Number(readField(comp, 'shadowX', 0)) || 0;
  const y = Number(readField(comp, 'shadowY', 0)) || 0;
  const blur = Number(readField(comp, 'shadowBlur', 8)) || 0;
  let color = String(readField(comp, 'shadowColor', '#0096ff') || '#0096ff');

  // 颜色归一化为 rgba(...,0.2)：接受 #rrggbb / rgb() / rgba()
  try {
    if (color.startsWith('#')) {
      const hex = color.replace('#', '');
      const r = parseInt(hex.slice(0, 2), 16);
      const g = parseInt(hex.slice(2, 4), 16);
      const b = parseInt(hex.slice(4, 6), 16);
      color = `rgba(${r}, ${g}, ${b}, 0.2)`;
    } else if (color.startsWith('rgb(')) {
      const m = color.match(/rgba?\(([^)]+)\)/);
      if (m) {
        const parts = m[1].split(',').map((s) => s.trim());
        color = `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, 0.2)`;
      }
    }
  } catch { /* 保持原色 */ }

  // 若全为 0（无偏移无模糊），返回 none（无阴影）
  if (x === 0 && y === 0 && blur === 0) return undefined;
  return `${x}px ${y}px ${blur}px ${color}`;
}